
import { connect } from 'react-redux'
import { compose, branch, renderComponent, renderNothing, lifecycle } from 'recompose'
import Cultivations from './Cultivations'

const Component = compose(
  connect(state => {
    return {
      items: state.breadcrumb
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.dispatch({
        type: 'SET_BREADCRUMB',
        items: [
          { page: 'Home', url: '/' },
          { page: 'Cultivos', url: '#' },
        ]
      })
    }
  }),
  branch(
    () => {
      return true
    },
    renderComponent(Cultivations),
    renderNothing
  )
)(Cultivations)

export default Component